import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
export default {
  name: 'rightmenu',
  props: {
    closeState: Boolean,
    changeMenu: Function
  },
  data: function data() {
    return {
      showState: '1',
      countryCode: 'us'
    };
  },
  methods: {
    KEWLSensorTrack: function KEWLSensorTrack(pathname) {
      util.KEWLSensorTrack({
        lmweb_clickText: '跳转',
        lmweb_tabName: pathname
      });
    },
    showItem: function showItem(state) {
      this.showState = state;
    },
    close: function close() {
      this.changeMenu(true);
    },
    getHeaderLink: function getHeaderLink(pathname) {
      var local = util.getI18nLocale();
      local = pathname == '/' ? '' : local;
      // 带参传递
      var json = {
        pathname: "/".concat(local).concat(pathname == '/' ? '' : pathname),
        search: {}
      };
      return util.directToPath(json, true);
    },
    goPopular: function goPopular() {
      window.location.href = this.getHeaderLink('/explore.html');
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return util.getI18nCountryCode(_this.$route && _this.$route.params.countryCode);
          case 2:
            _this.countryCode = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};